<template v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" ></spinner>


    <div class="page lead-page mt-3" v-else-if="loaded" >
        
        <div class="row no-gutters graymedium-color font-size-14" >
            <div class="col text-left" > <font-awesome-icon icon="user" /> LEAD </div>
            <div class="col text-right" > 
                <span class="cursor-pointer hover-color-grayDark font-size-14" @click="copy(data.id)" >
                    {{data.id}} <font-awesome-icon icon="copy" v-if="data.id != '' "  ></font-awesome-icon> 
                </span>
            </div>
        </div>

        <div class="row no-gutters page-section text-left" >
            <div class="col-12 page-section-heading" >

                <div class="col-12 m-0 p-0 mb-1" v-if="data.primary_lead" >
                    <span class="graymedium-color" > Primary lead: </span> 
                    <!--
                    <router-link :to="{name: 'LeadPage', params: { ID: data.primary_lead } }" class="not-active text-bold" > {{data.primary_email}} </router-link> 
                    -->
                    <a @click="routePrimaryLead(data.primary_lead)" > {{data.primary_email}}  </a>

                </div>

                <h1 class="h1 text-bold d-inline-block pb-2" > 
                    <span class="" >
                        <router-link :to="{name: 'Lead', params: { ID: data.id } }" class="not-active font-800 color-black h1 font-secondary" >
                            <span v-if="data.email != '' " > {{data.email}}  </span>
                            <span v-else-if="data.email == '' " > Unknown email ( visitor )  </span>
                        </router-link> 
                        <font-awesome-icon icon="copy" v-if="data.email != '' " class="cursor-pointer graymedium-color h4" @click="copy(data.email)" ></font-awesome-icon>
                    </span>
                </h1>

                <span class="actions-span d-inline-block float-right"  >
                    
                    <b-dropdown size="sm" html='Actions <svg aria-hidden="true" class="atlass-icon icon-chevron-down fill-white" height="14" width="14" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M13.591 5.293a1 1 0 0 1 1.416 1.416l-6.3 6.3a1 1 0 0 1-1.414 0l-6.3-6.3A1 1 0 0 1 2.41 5.293L8 10.884z" fill-rule="evenodd"></path></svg>' variant="primary" right split-variant class="font-size-14">
                        
                        <b-dropdown-item-button v-if="type == 'page'" class="d-none" >Edit</b-dropdown-item-button>
                        <b-dropdown-item-button v-else-if="type != 'page'" @click="()=>{ this.$router.push({ name: 'Lead', params: { ID: data.id } }); }" >
                            See details
                            <router-link :to="{name: 'Lead', params: { ID: data.id } }" class="d-none" > See details </router-link> 
                        </b-dropdown-item-button>
                        
                        <b-dropdown-item-button v-if="userRole == 0" @click="reattributeOrders( )" > Reattribute orders </b-dropdown-item-button>
                        <b-dropdown-item-button v-if="userRole == 0" @click="preventMergeLeads( )" > Merge leads ( BETA ) </b-dropdown-item-button>
                        <b-dropdown-item-button v-if="userRole == 0" @click="preventImportEvents( )" > Import events ( last 72h ) </b-dropdown-item-button>
                        <b-dropdown-item-button v-if="userRole == 0" @click="importEvents( )" > Import events from all IPs ( last 72h ) </b-dropdown-item-button>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item-button @click="preventDelete()" >Delete</b-dropdown-item-button>
                        <b-dropdown-item-button v-if="userRole == 0" variant="danger" @click="preventDelete( deleteEvents = true )" >Delete with events</b-dropdown-item-button>
                    </b-dropdown>
                    
                    
                </span>
            </div>
        </div>

        <div class="row no-gutters page-section mt-1 font-400 flex-wrap-scroll leadDetails-stats" >

            <div class="d-inline-block border-right-gray p-2 pl-0 pr-4" v-if="type == 'page'" >
                <div> 
                    <span class="graymedium-color font-400 font-size-14" > Revenue: </span> 
                    <br>
                        {{ formatRevenue( data.revenue ) }}
                </div>
            </div>

            <!--
            <div class="d-inline-block border-right-gray p-2 pl-4 pr-4" >
                <div> 
                    <span class="graymedium-color font-400 font-size-14" > Customer LTV: </span> 
                    <br>
                        {{ formatRevenue( data.revenue ) }}
                </div>
            </div>
            -->

            <div class="d-inline-block border-right-gray p-2 pl-4 pr-4" v-if="data.datetime_created" >
                <div> 
                    <span class="graymedium-color font-400 font-size-14" > Created at: </span> 
                    <br>
                        {{formatDate(data.datetime_created)}}
                </div>
            </div>

            <div class="d-inline-block border-right-gray p-2 pl-4 pr-4" v-else-if="!data.datetime_created" >
                <div> 
                    <span class="graymedium-color font-400 font-size-14" > First seen: </span> 
                    <br>
                        {{formatDate(data.datetime)}} 
                </div>
            </div>

            <div class="d-inline-block border-right-gray p-2 pl-4 pr-4" v-if="isAdmin" >
                <div> 
                    <span class="graymedium-color font-400 font-size-14" > IP Address: </span> 
                    <br>
                        {{ data.IP }} 
                </div>
            </div>

            <div class="d-inline-block border-right-gray p-2 pl-4 pr-4" v-if="data.location" >
                <div> 
                    <span class="graymedium-color font-400 font-size-14" > Location: </span> 
                    <br>
                        <span v-if="data.location.city" > {{ data.location.city }}, </span> 
                        <span v-else-if="data.location.city == ''" > Unknown, </span> 
                        {{ data.location.country }} 
                </div>
            </div>

            <div class="d-inline-block border-right-gray p-2 pl-4 pr-4" v-if="data.firstname" >
                <div> 
                    <span class="graymedium-color font-400 font-size-14" > Name: </span> 
                    <br>
                    <span v-if="data.firstname" > {{data.firstname}} {{data.lastname}}  </span>
                    <span v-else-if="data.firstname" > No name </span>
                </div>
            </div>

            <div class="d-inline-block border-right-gray p-2 pl-4 pr-4" v-if="data.phone" >
                <div> 
                    <span class="graymedium-color font-400 font-size-14" > Phone: </span> 
                    <br>
                        {{data.phone}}
                </div>
            </div>

            <div class="d-inline-block border-right-gray p-2 pl-4 pr-4 d-none"  v-if="data.AVG_CONVERT" >
                <div> 
                    <span class="graymedium-color font-400 font-size-14" > Average Conversion Duration </span> 
                    <br>
                        <span > {{ secondsToDhms( data.AVG_CONVERT ) }} </span>
                </div>
            </div>
            
            <div class="d-inline-block p-2 pl-4 pr-4" >
                <div> 
                    <span class="graymedium-color font-400 font-size-14" > First touch: </span> 
                    <br>
                        <span v-if="data.firstTouch != 'unknown'" > {{data.firstTouch.tag}} </span>
                        <span v-else-if="data.firstTouch == 'unknown'" > unknown ( organic ) </span>
                </div>
            </div>
            

        </div>

        <div class="row no-gutters page-section mt-4 d-none" >
            <div class="col-12 page-section-heading" >
                <h2 class="h2 text-bold" > Details </h2>
            </div>
            <div class="col-12"  >
                <div class="field" > <span class="span-width graymedium-color font-300" > Firstname: </span> {{data.firstname}} </div>
                <div class="field"> <span class="span-width graymedium-color font-300" > Lastname: </span> {{data.lastname}} </div>
                <div class="field"> <span class="span-width graymedium-color font-300" > Phone: </span> {{data.phone}} </div>
            </div>
        </div>
        
        <modal :modalData="modalData" :modalState="modalState" :modalComponent="modalComponent" modalClass="narrow" ></modal>

    </div>
</template>

<script>

import { mapGetters, mapState } from 'vuex'
import firebase from "firebase";
import Cookies from 'js-cookie'  
import helper from '@/helpers/helpers.js';
import axios from 'axios'
    
export default {
    name: 'leadDetails',
    props: {
        data: { 
            type: [Object],
        },
        type:{
            type: [String]
        }
    },
    components:{
        modal: () => import('@/components/modal.vue')
    },
    data: function(){
        return {
            loaded: false,
            dropdown: false,
            modalData: null,
            modalState: false,
            modalState: false,
            modalComponent: null
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        
    },
    mounted: function () {
        this.loaded = true;
            
        //console.log(this.data)
    },
    beforeDestroy() {
    },
    methods: {
        
        fModalOpen( data, component ){
            this.modalData = data
            this.modalState = true
            this.modalComponent = component
        },
        
        formatDate(datetime){
            //return this.$moment.unix(datetime).format( 'HH:mm MMM D, YYYY' )
            return helper.formatDate( datetime, 'HH:mm MMM D, YYYY' )
        },
        formatRevenue( revenue ){
          
            return helper.formatNumberWithCurrency( revenue )
            
        },
        copy( text ){
            
            let textToCopy = text
            navigator.clipboard.writeText(textToCopy);
            
            this.$toast.success({
                title:'Success',
                message:  'Copied to clipboard!'
            })
            
        },
        dropdownToggle(){
            if( this.dropdown == false ){
                this.dropdown = true
            }else{
                this.dropdown = false
            }
            
        },
        
        reattributeOrders(){
            
            //this.loaded = false
            
            let params = Cookies.get('user-token')
            
            //APPKEY, LEADID, IP_SALT, startdate
            let data = {
                APPKEY: helper.getLoggedInOrganization( this.$store.getters.isAdmin ),
                leadID: this.data.id,
            }
                        
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8', "xauth": params }
            
            axios({ method: 'POST', url: process.env.ROOT_API+'/app/reattribute-orders', headers: headers, data: data })
                .then(resp => {
                
                console.log(resp)
                
                if( resp.status == 200 ){
                    let r = resp.data;
                    if( r.status == 100 ){
                        
                        this.$toast.success({
                            title: 'Success',
                            message: 'Order reprocessed.'
                        })
                            
                    }else{
                        
                        this.$toast.warn({
                            title: 'Warning',
                            message: r.data
                        })
                        
                    }
                }
                    
                
            }).catch(error => {
                console.log(error)
            }); //end axios 
            
            
        },
        
        preventMergeLeads(){
            
            this.fModalOpen( this.data, 'leadToMerge' )
            
        },
        
        preventImportEvents(){
            
            this.fModalOpen( this.data, 'importEvents' )
            
        },
        
        mergeLeads(leadToMerge){
            
            //this.loaded = false
            
            let params = Cookies.get('user-token')
            
            //APPKEY, LEADID, IP_SALT, startdate
            let data = {
                APPKEY: helper.getLoggedInOrganization( this.$store.getters.isAdmin ),
                leadID: this.data.id,
                leadToMerge : leadToMerge
            }
                        
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8', "xauth": params }
            
            axios({ method: 'POST', url: process.env.ROOT_API+'/app/merge-leads', headers: headers, data: data })
                .then(resp => {
                
                //console.log(resp)
                
                if( resp.status == 200 ){
                    let r = resp.data;
                    if( r.status == 100 ){
                        
                        this.$toast.success({
                            title: 'Success',
                            message: 'Leads merged.'
                        })
                        
                        this.modalState = false
                        
                    }else{
                        
                        this.$toast.warn({
                            title: 'Warning',
                            message: r.data
                        })
                        
                    }
                }
                    
                
            }).catch(error => {
                console.log(error)
            }); //end axios 
            
            
        },
        
        importEvents( IP ){
            
            //this.loaded = false
            
            let params = Cookies.get('user-token')
            
            //APPKEY, LEADID, IP_SALT, startdate
            let data = {
                APPKEY: helper.getLoggedInOrganization( this.$store.getters.isAdmin ),
                leadID: this.data.id,
            }
                        
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8', "xauth": params }
            
            axios({ method: 'POST', url: process.env.ROOT_API+'/app/import-all-events', headers: headers, data: data })
                .then(resp => {
                
                //console.log(resp)
                
                if( resp.status == 200 ){
                    let r = resp.data;
                    if( r.status == 100 ){
                        
                        this.$toast.success({
                            title: 'Success',
                            message: 'Events imported'
                        })
                        
                        this.modalState = false
                        
                    }else{
                        
                        this.$toast.warn({
                            title: 'Warning',
                            message: r.data
                        })
                        
                    }
                }
                    
                
            }).catch(error => {
                console.log(error)
            }); //end axios 
            
            
        },
        
        preventDelete( deleteEvents = false ){
            
            this.$swal({
                title: 'Are you sure?',
                text: 'This cannot be undone and the lead will be deleted as well',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) { 
                    
                    //this.delete( deleteEvents );
                    let leadID = this.data.id
                    this.delete_from_SQL( leadID )
                }
            })
            
        },        
        delete: function( deleteEvents ){
            
            this.loaded = false
            let leadID = this.data.id
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            
            const db = firebase.firestore();
            
            //DELETE TAGS
            db.collection('organizations/'+orgID+'/leads/'+leadID+'/tags').get()
            .then((querySnapshot) => {
                querySnapshot.forEach(function(doc) {
                    doc.ref.delete();                    
                });
            });
            
            //DELETE CLICKS
            db.collection('organizations/'+orgID+'/leads/'+leadID+'/clicks').get()
            .then((querySnapshot) => {
                querySnapshot.forEach(function(doc) {
                    doc.ref.delete();                    
                });
            });
            
            //DELETE LEAD
            db.collection('organizations/'+orgID+'/leads').doc( leadID ).delete()
            
            //DELETE ORDERS
            db.collection('organizations/'+orgID+'/orders').where( 'leadID', '==', leadID ).get()
            .then((querySnapshot) => {
                querySnapshot.forEach(function(doc) {
                    doc.ref.delete();
                    //console.log(doc.data())
                    let ORDER = doc.data()
                    
                    //UPDATE PRODUCT REVENUE
                    let decrement = firebase.firestore.FieldValue.increment( -Math.abs(ORDER.price) )

                    db.collection('organizations/'+orgID+'/products').where( 'tag', '==', ORDER.tag ).get()
                    .then((result)=>{
                        result.forEach(doc =>{
                            let PRODUCT = doc.data()
                            let PRODUCT_ID = doc.id;
                            //db.collection('organizations/'+orgID+'/products').doc( PRODUCT_ID ).update( { revenue: decrement } );
                        })
                    })
                    //UPDATE PRODUCT REVENUE
                    
                });
            });
               
            //REMOVE PRIMARY EMAIL FOR OTHER LEADS
            
            //DELETE EVENTS
            db.collection('organizations/'+orgID+'/events').where( 'leadID', '==', leadID ).get()
            .then((querySnapshot) => {
                querySnapshot.forEach(function(doc) {
                    doc.ref.delete();   

                });
            });
            
            this.delete_from_SQL(leadID )
            
            //console.log("Success")
            this.$toast.success({
                title: 'Success',
                message: 'Lead has been deleted'
            })

            setTimeout(function(){ 
                this.loaded = true
                this.$router.push({
                    name: 'Leads'
                }); 
            }.bind(this), 100 );
                
        },
        
        delete_from_SQL(leadID){
              
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8', "xauth": Cookies.get('user-token') }
            
            axios({ 
                method: 'POST', 
                //url: process.env.ROOT_API+'/analyze/sales', 
                //url: process.env.ROOT_API+'/sql/orders/delete', 
                url: process.env.ROOT_API+'/sql/lead/delete', 
                headers: headers, 
                data: { 
                    "APPKEY": helper.getLoggedInOrganization( this.$store.getters.isAdmin ),
                    //"APPKEY": ( ( this.passedAPPKEY != false ) ? this.passedAPPKEY : helper.getLoggedInOrganization( this.$store.getters.isAdmin ) ),
                    "leadID": leadID
                } 
            })
            .then(resp => {
                //console.log(resp)
                
            })
            .then(function(sales){
                
                this.$toast.success({
                    title: 'Success',
                    message: 'Lead has been deleted'
                })

                setTimeout(function(){ 
                    this.loaded = true
                    this.$router.push({
                        name: 'Leads'
                    }); 
                }.bind(this), 100 );
                
            }.bind(this))
            .catch(error => {
                
                console.log(error)
                this.$toast.error({
                    title:'Error',
                    message:  'Error deleting lead. Please reach out to us!'
                })
                
            }); //end axios 
            
        },
        
        routePrimaryLead(ID){
            
            if( this.type == 'page' ){
                this.$router.push({
                    name: 'Lead',
                    params: { ID: ID }
                });
            }else if( this.type == 'component' ){
                this.$parent.loaded = false;
                //console.log(this.$parent.docID)
                this.$parent.docID = ID;          
                this.$parent.get_lead();

                //console.log(this.$parent.docID)
                if( this.$parent.selectedTab == 'tags' ){
                    this.$parent.getTags();
                }else{
                    this.$parent.getClicks();
                }
                
                //console.log( this.$parent)
                
                //this.$parent.$refs.tags.$el.click()
                
                this.$parent.loaded = true;
            }
                                
        },
        
        secondsToDhms( duration ){
            return helper.secondsToDhms(duration)
        }
        
    },
    computed: {
        isAdmin(){
            return this.$store.getters.isAdmin
        },
        userRole(){
            return this.$store.getters.getRole
        },
    },
    watch: {
        data: function(){
            return this.data 
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" >


    .field{
        margin: 5px 0;
    }
    
    .span-width{
        min-width: 180px;
        max-width: 240px;
        display: inline-block;

    }
    
</style>



// WEBPACK FOOTER //
// src/components/leadDetails.vue